import { graphql } from "../../generated"

export const MOTION_TIMELINE_QUERY = graphql(`
    query motionTimelineQuery(
        $motionTimelineInput: TimelineInput!
        $intentTimelineInput: TimelineInput!
    ) {
        motionTimeline: eventTimeline(input: $motionTimelineInput) {
            series {
                ...ControlObservationTimelineSeriesMetaData
            }
        }

        intentTimeline: eventTimeline(input: $intentTimelineInput) {
            series {
                timeline {
                    ...ControlIntentTimelineFields
                }
            }
        }
    }
`)
